// src/utils/axiosConfig.js
import axios from 'axios';
import userManager, { redirectToSignIn } from '../auth/oidcConfig';

// Configure axios to include authentication
const setupAxiosInterceptors = async () => {
  // Request interceptor to add authorization token
  axios.interceptors.request.use(
    async (config) => {
      try {
        const user = await userManager.getUser();
        
        // If we have a valid user with token, add it to requests
        if (user && !user.expired) {
          config.headers.Authorization = `Bearer ${user.access_token}`;
        }
        
        return config;
      } catch (error) {
        console.error('Error adding auth token to request:', error);
        return config;
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Response interceptor to handle 401/403 errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      // If unauthorized, try to renew token silently
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.log('Received auth error, attempting silent renewal...');
        
        try {
          // Try silent renewal
          const user = await userManager.signinSilent();
          
          if (user && !user.expired) {
            // Retry the original request with new token
            const originalRequest = error.config;
            originalRequest.headers.Authorization = `Bearer ${user.access_token}`;
            return axios(originalRequest);
          }
        } catch (renewError) {
          console.error('Silent renewal failed:', renewError);

          // Redirect to login if needed
          redirectToSignIn();
        }
      }
      
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
